import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "../../../examples/Tables/DataTable";
import data from "../../dashboard/components/Projects/data";
import useApi from "../../../components/Utils/api";
import toast from "react-hot-toast";
import { DateRangePicker } from "rsuite";
import { afterToday } from "rsuite/cjs/DateRangePicker/disabledDateUtils";
import reportsLineChartData from "../../dashboard/data/reportsLineChartData";
import Papa from 'papaparse';

function CashTransactions() {
  const { cashTransactionsReportsColumns } = data();
  const { predefinedRanges } = reportsLineChartData;
  const [transactions, setTransactions] = useState([]);
  const getTodayDateAtMidnight = () => {
    const now = new Date();
    now.setHours(0, 0, 0, 0); // Set to start of the day
    const offset = now.getTimezoneOffset(); // Get timezone offset in minutes
    now.setMinutes(now.getMinutes() - offset); // Adjust by offset to get local time
    return now;
  };

  // Initialize lastMonthDateRange to today's date at local midnight
  const [lastMonthDateRange, setLastMonthDateRange] = useState([
    getTodayDateAtMidnight().toISOString().slice(0, 10),
    getTodayDateAtMidnight().toISOString().slice(0, 10)
  ]);
  const api = useApi();

  const formatDate = (date) => {
    const isoDate = new Date(date.toLocaleString("en-US", { timeZone: "Australia/Sydney" })).toISOString();
    return isoDate.slice(0, 10);
  };

  const getTransactions = (lastMonthDateRange) => {
    if (lastMonthDateRange == null) return;
    setLastMonthDateRange(lastMonthDateRange);
    const data = {
      fromDate: formatDate(lastMonthDateRange[0]),
      toDate: formatDate(lastMonthDateRange[1])
    };
    api.post("reports/getcashtransactionSummary", data)
      .then((response) => {
        if (response.data.statusCodeValue === 200) {
          setTransactions(response.data.body);
        }else { const toastId = toast.error("No Record Found", { autoClose: false }); // Prevents auto-closing
        setTimeout(() => toast.dismiss(toastId), 1000); // Dismisses the toast after 1 second
        
          setTransactions([]);
      
      }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        const toastId = toast.error("No Record Found", { autoClose: false }); // Prevents auto-closing
        setTimeout(() => toast.dismiss(toastId), 1000); // Dismisses the toast after 1 second
      });
  };

  const generateCSV = () => {
    if (transactions.length === 0) {
      return '';
    }

    const headers = cashTransactionsReportsColumns.map(column => column.Header);

    const transactionsWithUppercaseColumns = transactions.map(transaction => {
      return cashTransactionsReportsColumns.map(column => {
        const accessor = column.accessor;
        const value = typeof accessor === 'function' ? accessor(transaction) : transaction[accessor];
        return value;
      });
    });

    const csvData = [headers, ...transactionsWithUppercaseColumns];

    const csv = Papa.unparse(csvData, {
      quotes: true,
    });

    return csv;
  };

  const handleDownloadCSV = () => {
    if (transactions.length === 0) {
      const toastId = toast.error("No records found to download", { autoClose: false }); // Prevents auto-closing
      setTimeout(() => toast.dismiss(toastId), 1000); // Dismisses the toast after 1 second
      return;
    }

    const csvData = generateCSV();

    const currentDate = new Date().toISOString().slice(0, 10);
    const currentTime = new Date().toLocaleTimeString().replace(/:/g, '-');
    const dateTimeString = `${currentDate}_${currentTime}`;

    const fileName = `CashTransactions_${dateTimeString}.csv`;

    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  useEffect(() => {
    getTransactions(lastMonthDateRange);
  }, [lastMonthDateRange]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3} textAlign={"center"}>
              <DateRangePicker
  disabledDate={afterToday()}
  ranges={predefinedRanges}
  onChange={(date) => {
    setLastMonthDateRange(date);  // Directly update lastMonthDateRange
    getTransactions(date);        // Call getTransactions with the selected date range
  }}
  format="yyyy-MM-dd"
  value={
    lastMonthDateRange.length !== 0 
      ? [new Date(lastMonthDateRange[0]), new Date(lastMonthDateRange[1])] 
      : []
  }
/>

              </MDBox>
            </Grid>
            <MDButton
              variant="gradient"
              onClick={handleDownloadCSV}
              color="info"
              style={{ marginRight: "24px", marginBottom: "12px" }}
            >
              Export
            </MDButton>
            <DataTable
              table={{ columns: cashTransactionsReportsColumns, rows: transactions }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={true}
              canSearch={true}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CashTransactions;
